import { Badge, Text, Tooltip } from '@fullstory/components';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const AutoGenPill = () => (
  <Tooltip
    data-component="AutoGenPill"
    placement="right"
    variant="light"
    tooltipContent={
      <Text appearance="bodySmall">
        <FormattedMessage defaultMessage="Automatically generated by Fullstory." id="FilhAY" />
      </Text>
    }
  >
    <Badge variant="intelligence">
      <FormattedMessage
        defaultMessage="Auto"
        id="/aB7JV"
        description="A pill specifying that an object was Auto Generated"
      />
    </Badge>
  </Tooltip>
);
